import { useImmutableContext, useImmutableContextProvider } from "@devowl-wp/react-utils";
const LIST_TCF_VENDOR_SYMBOL = Symbol();
const useListTcfVendor = ()=>useImmutableContext(LIST_TCF_VENDOR_SYMBOL);
const useListTcfVendorProvider = (...args)=>useImmutableContextProvider(LIST_TCF_VENDOR_SYMBOL, ...args);
export { useListTcfVendor, useListTcfVendorProvider };
